import { useState, useEffect } from 'react';
import { useWeb3js } from '../web3/web3Client';
import { fetchPublisherNFTs, fetchGenesis } from '../services/wallet';
import { genesisChainId } from '../pages/Staking/constants';

export function useStakable(account, ready) {
    const [stakable, setStakable] = useState([])
    const [fetching, setFetching] = useState(false)
    const [fetched, setFetched] = useState(false)

    useEffect(() => {
        const controller = new AbortController();
        const { signal } = controller;

        if(ready && account && !fetched) {
            setStakable([])
            setFetching(true)
            fetchPublisherNFTs(account, signal)
                .then(nfts => {
                    // console.log(nfts)
                    setStakable(nfts.token_ids)
                })
                .catch(e => {
                    console.error(e)
                    setStakable([]);
                })
                .finally(() => {
                    setFetching(false)
                    setFetched(true)
                })
        }

        // return () => setStakable([]);
    }, [account, ready])


    return { stakable, fetching, fetched };
}

export function useGenesisBalance(account, ready) {
    const [genesis, setGenesis] = useState([0, 0])
    const [fetching, setFetching] = useState(false)
    const [fetched, setFetched] = useState(false)
    const web3 = useWeb3js({ chainId: genesisChainId});

    useEffect(() => {
        if(ready && account) {
            setGenesis([0, 0])
            setFetching(true)
            fetchGenesis(web3, account)
                .then(nfts => {
                    setGenesis(nfts.map(x => parseInt(x)))
                })
                .catch(e => {
                    console.error(e)
                    setGenesis([0, 0]);
                })
                .finally(() => {
                    setFetching(false)
                    setFetched(true)
                })
        }

        // return () => setGenesis([]);
    }, [account, ready])


    return { genesis, fetching, fetched };
}